// extracted by mini-css-extract-plugin
module.exports = {"sectionCompare":"SectionCompare_sectionCompare_2raE1"};